import { styled } from 'src/stitches.config';

export const Canvas = styled('canvas', {
  border: '1px solid black',
  position: 'absolute',
});
